export default {
  "head.index": "Home",
};
